import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getMessageHash } from '../../utils/get_message_hash';
import type { Message, MessagesState } from './types';

const initialState: MessagesState = {};

export const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    showMessage: (state, action: PayloadAction<Message>) => {
      state[getMessageHash(action.payload)] = action.payload;
    },

    clearMessage: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
    // This action is used to clear messages that should not persist across navigation
    clear: (state) =>
      Object.fromEntries(
        Object.entries(state).filter(
          ([, message]) => message.persistOnNavigation,
        ),
      ),
  },
});

export const { showMessage, clearMessage, clear } = messagesSlice.actions;

export const messagesReducer = messagesSlice.reducer;
